import React, { ReactNode, useEffect, useState } from "react";
import styled from "styled-components";
import { LayoutProps } from "styled-system";

import Box from "../Box/Box";

const Container = styled(Box)<{ hoverEnabled: boolean }>`
  ${(props) => `   pointer-events: ${props.hoverEnabled ? "auto" : "none"};
> .hover-card {
  transform: translateY(-50%);
  position: absolute;
  top: 50%;
  z-index: 1;
}`}
`;

const ItemWrapper = ({
  children,
  maxSlideHeight,
  animationDelay,
}: {
  children: ReactNode;
  maxSlideHeight: LayoutProps["maxHeight"];
  animationDelay: number;
}) => {
  const [hoverClass, setHoverClass] = useState("");
  const [hoverEnabled, setHoverEnabled] = useState(false);

  let animationTimeout: NodeJS.Timeout;

  useEffect(() => {
    let hoverTimeout: NodeJS.Timeout;
    if (!hoverEnabled) {
      hoverTimeout = setTimeout(() => {
        setHoverEnabled(true);
      }, 500);
    }
    return () => clearTimeout(hoverTimeout);
  }, [hoverEnabled]);

  const handleHoverState = (e: React.MouseEvent<HTMLDivElement>) => {
    clearTimeout(animationTimeout);
    if (e.type === "mouseenter") {
      setHoverClass("hover-card");
      return;
    }
    if (e.type === "mouseleave") {
      animationTimeout = setTimeout(() => {
        setHoverClass("");
      }, animationDelay);
    }
  };
  return (
    <Container
      display="flex"
      width="100%"
      minHeight={maxSlideHeight}
      hoverEnabled={hoverEnabled}
    >
      <Box
        maxWidth="100%"
        className={hoverEnabled ? hoverClass : ""}
        minHeight={maxSlideHeight}
        display="flex"
        width="100%"
        onMouseEnter={hoverEnabled ? handleHoverState : undefined}
        onMouseLeave={handleHoverState}
      >
        {children}
      </Box>
    </Container>
  );
};

export default ItemWrapper;
